// Google Ads / gtag helpers.
// Set REACT_APP_GOOGLE_ADS_ID (e.g. "AW-1234567890") in frontend/.env to activate.
// Conversion tracking requires both REACT_APP_GOOGLE_ADS_ID and the per-event conversion
// label set at REACT_APP_GOOGLE_ADS_CONVERSION_LABEL (e.g. "abc123DEF456").
// When either is missing, all calls no-op silently — safe to ship without keys.

const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const CONV_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || "";

let initialized = false;

function ensureGtag() {
  if (!ADS_ID) return null;
  if (initialized) return window.gtag;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", ADS_ID);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ADS_ID)}`;
  document.head.appendChild(s);
  initialized = true;
  return window.gtag;
}

export function initGoogleAds() {
  ensureGtag();
}

/**
 * Fire a Google Ads conversion event.
 * @param {object} [opts]
 * @param {string} [opts.sourceService] slug of the service page (adds transaction_id + custom param)
 * @param {number} [opts.value] optional conversion value in USD
 */
export function trackAdsConversion(opts = {}) {
  const g = ensureGtag();
  if (!g || !CONV_LABEL) return false;
  const params = {
    send_to: `${ADS_ID}/${CONV_LABEL}`,
    value: typeof opts.value === "number" ? opts.value : 1.0,
    currency: "USD",
  };
  if (opts.sourceService) {
    params.transaction_id = `${opts.sourceService}-${Date.now()}`;
    params.service_slug = opts.sourceService;
  }
  g("event", "conversion", params);
  return true;
}
